import React from 'react';

function ArrowRight() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M7.62582 0.277061C7.25389 -0.0923537 6.65087 -0.0923537 6.27895 0.277061C5.90702 0.646476 5.90702 1.24542 6.27895 1.61483L10.6939 6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8H10.6939L6.27895 12.3852C5.90702 12.7546 5.90702 13.3535 6.27895 13.7229C6.65087 14.0924 7.25389 14.0924 7.62582 13.7229L13.5608 7.8281C13.8251 7.64875 13.999 7.34613 14 7.00284L14 7L14 6.99716C13.999 6.65387 13.8251 6.35125 13.5608 6.1719L7.62582 0.277061Z'
        fill='white'
      />
    </svg>
  );
}

export default ArrowRight;
